(function (process,global,Buffer,__argument0,__argument1,__argument2,__argument3,__filename,__dirname){
var schemata = require('schemata')
  , validateIfSet = require('@clocklimited/validity-validate-if-set')
  , festivalYearSchema = require('./festival-year-schema')
  , festivalFileSchema = require('./festival-file-schema')
const required = require('@clocklimited/validity-required')
const url = require('@clocklimited/validity-url')

module.exports = function () {
  return schemata(
    { _id:
      { type: String
      }
    , name:
      { type: String
      , validators: { all: [ required ] }
      }
    , website:
      { type: String
      , validators: { all: [ validateIfSet(url) ] }
      }
    , genre:
      { type: Array
      , validators: { all: [ required ] }
      }
    , files:
      { type: schemata.Array(festivalFileSchema)
      }
    , promoter:
      { type: Array
      , defaultValue: function () { return [] }
      }
    , contact:
      { type: Array
      , defaultValue: function () { return [] }
      }
    , category:
      { type: String
      , validators: { all: [ required ] }
      }
    , years:
      { type: schemata.Array(festivalYearSchema)
      , validators: { all: [ required ] }
      }
    , createdDate:
      { type: Date
      , defaultValue: function () { return new Date() }
      }
    }
  )
}

}).call(this,require('_process'),typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/components/service/festival/schema.js","/components/service/festival")
//# sourceMappingURL=data:application/json;charset:utf-8;base64,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